'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * @internal
 */
var gestureProps = ["onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "onHoverStart", "onHoverEnd", "whileFocus", "whileTap", "whileHover"];

exports.gestureProps = gestureProps;
